import {
  Card,
  Row,
  Col,
  Spinner,
  Alert,
  Modal,
  Navbar,
  Form,
  InputGroup,
  Button,
  Image,
  Dropdown,
  Accordion,
  Container,
  Nav,
  ProgressBar,
  Placeholder,
  Table,
  Badge,
} from "react-bootstrap";
import { Markup } from "react-render-markup";
import { Navigation } from "react-minimal-side-navigation/lib";
import BrtxSelect from "./BrtxSelect";
import BrtxCustom from "./BrtxCustom/index";
import BrtxEditor from "./BrtxEditor";
import BrtxDropzone from "./BrtxDropzone";
import BrtxAsyncSelect from "./BrtxAsyncSelect";
import Logo from "../assets/img/hvezda.png";
import BrtxSpin from "./BrtxSpin";

const _bs = (props) => {
  /* CARDS */
  if (props.card) return <Card {...props}>{props.children}</Card>;
  if (props.cardbody) return <Card.Body {...props}>{props.children}</Card.Body>;
  if (props.cardtitle)
    return <Card.Title {...props}>{props.children}</Card.Title>;
  if (props.cardheader)
    return <Card.Header {...props}>{props.children}</Card.Header>;
  if (props.cardfooter)
    return <Card.Footer {...props}>{props.children}</Card.Footer>;

  /* ROW COL CONTAINER */
  if (props.row) return <Row {...props}>{props.children}</Row>;
  if (props.col) return <Col {...props}>{props.children}</Col>;
  if (props.container)
    return <Container {...props}>{props.children}</Container>;

  /* SPINNER */
  if (props.spinner) return <Spinner {...props}>{props.children}</Spinner>;

  /* ACCORDION */
  if (props.accordion)
    return <Accordion {...props}>{props.children}</Accordion>;
  if (props.accordioncollapse)
    return <Accordion.Collapse {...props}>{props.children}</Accordion.Collapse>;
  if (props.accordionheader)
    return <Accordion.Header {...props}>{props.children}</Accordion.Header>;
  if (props.accordionbody)
    return <Accordion.Body {...props}>{props.children}</Accordion.Body>;
  if (props.accordionitem)
    return <Accordion.Item {...props}>{props.children}</Accordion.Item>;

  /* ALERT */
  if (props.alert) return <Alert {...props}>{props.children}</Alert>;
  if (props.alertheading)
    return <Alert.Heading {...props}>{props.children}</Alert.Heading>;

  /* MODAL */
  if (props.modal) return <Modal {...props}>{props.children}</Modal>;
  if (props.modalheader)
    return <Modal.Header {...props}>{props.children}</Modal.Header>;
  if (props.modalbody)
    return <Modal.Body {...props}>{props.children}</Modal.Body>;
  if (props.modaltitle)
    return <Modal.Title {...props}>{props.children}</Modal.Title>;
  if (props.modalfooter)
    return <Modal.Footer {...props}>{props.children}</Modal.Footer>;

  /* FORM CONTROL */
  if (props.formcontrol)
    return <Form.Control {...props}>{props.children}</Form.Control>;
  if (props.formrange)
    return <Form.Range {...props}>{props.children}</Form.Range>;
  if (props.formswitch)
    return <Form.Switch {...props}>{props.children}</Form.Switch>;
  if (props.formtext) return <Form.Text {...props}>{props.children}</Form.Text>;
  if (props.inputgroup)
    return <InputGroup {...props}>{props.children}</InputGroup>;
    if (props.inputgrouptext)
    return <InputGroup.Text {...props}>{props.children}</InputGroup.Text>;
  if (props.form) return <Form {...props}>{props.children}</Form>;

  /* COMPONENTS */
  if (props.button) return <Button {...props}>{props.children}</Button>;
  if (props.image) return <Image {...props}>{props.children}</Image>;
  if (props.progressbar)
    return <ProgressBar {...props}>{props.children}</ProgressBar>;
  if (props.badge) return <Badge {...props}>{props.children}</Badge>;

  /* CUSTOM COMPONENTS */
  if (props.bsmarkup) return <Markup {...props} />;
  if (props.brtxspin) return <BrtxSpin />;
  if (props.brtxcustom) return <BrtxCustom {...props} />;
  if (props.brtxselect)
    return <BrtxSelect {...props}>{props.children}</BrtxSelect>;
  if (props.brtxasyncselect)
    return <BrtxAsyncSelect {...props}>{props.children}</BrtxAsyncSelect>;
    if (props.brtxdropzone)
    return <BrtxDropzone {...props}>{props.children}</BrtxDropzone>;
  if (props.brtxeditor)
    return <BrtxEditor {...props}>{props.children}</BrtxEditor>;
  if (props.logo)
    return <Image src={Logo} className="c-logo c-squircle me-2" />;

  /* TABLE */
  if (props.table) return <Table {...props}>{props.children}</Table>;

  /* DROPDOWN */
  if (props.dropdown) return <Dropdown {...props}>{props.children}</Dropdown>;
  if (props.dropdowntoggle)
    return <Dropdown.Toggle {...props}>{props.children}</Dropdown.Toggle>;
  if (props.dropdownitem)
    return <Dropdown.Item {...props}>{props.children}</Dropdown.Item>;
  if (props.dropdownmenu)
    return <Dropdown.Menu {...props}>{props.children}</Dropdown.Menu>;
  if (props.dropdowndivider)
    return <Dropdown.Divider />;
  if (props.dropdownheader)
    return <Dropdown.Header {...props}>{props.children}</Dropdown.Header>;

  /* PLACEHOLDER */
  if (props.placeholder)
    return <Placeholder {...props}>{props.children}</Placeholder>;
  if (props.placeholderbutton)
    return <Placeholder.Button {...props}>{props.children}</Placeholder.Button>;

  /* NAV */
  if (props.navbar) return <Navbar {...props}>{props.children}</Navbar>;
  if (props.nav) return <Nav {...props}>{props.children}</Nav>;
  if (props.navitem) return <Nav.Item {...props}>{props.children}</Nav.Item>;
  if (props.navlink) return <Nav.Link {...props}>{props.children}</Nav.Link>;
  if (props.navbarbrand)
    return <Navbar.Brand {...props}>{props.children}</Navbar.Brand>;
  if (props.navigation)
    return <Navigation {...props}>{props.children}</Navigation>;

  /* HTML */
  if (props.div) return <div {...props}>{props.children}</div>;
  if (props.b) return <b {...props}>{props.children}</b>;
  if (props.span) return <span {...props}>{props.children}</span>;
  if (props.strong) return <strong {...props}>{props.children}</strong>;
  if (props.small) return <small {...props}>{props.children}</small>;
  if (props.h4) return <h4 {...props}>{props.children}</h4>;
  if (props.h5) return <h5 {...props}>{props.children}</h5>;
  if (props.br) return <br {...props}>{props.children}</br>;
  if (props.hr) return <hr {...props}>{props.children}</hr>;
  if (props.thead) return <thead {...props}>{props.children}</thead>;
  if (props.tr) return <tr {...props}>{props.children}</tr>;
  if (props.th) return <th {...props}>{props.children}</th>;
  if (props.td) return <td {...props}>{props.children}</td>;
  if (props.tbody) return <tbody {...props}>{props.children}</tbody>;
  if (props.p) return <p {...props}>{props.children}</p>;
  return null;
};
export default _bs;
